import { render, staticRenderFns } from "./cashier.vue?vue&type=template&id=8721e924&scoped=true&"
import script from "./cashier.vue?vue&type=script&lang=js&"
export * from "./cashier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8721e924",
  null
  
)

export default component.exports